import { render, staticRenderFns } from "./SucFileFieldComponent.vue?vue&type=template&id=46622081&scoped=true&"
import script from "./SucFileFieldComponent.vue?vue&type=script&lang=js&"
export * from "./SucFileFieldComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46622081",
  null
  
)

export default component.exports